define('mailsListMailsView',[
  'app',
  'module',
  'underscore',
  'tableView',
  'tableDatetimeFieldView',
  'mailsListMailView',
  'mailsMailView',
  'entities/mails'
], function (
    App,
    Module,
    _,
    TableView,
    DatetimeFieldView,
    ListMailView,
    MailView
) {
  'use strict';

  Module.exports = TableView.extend({
    className: 'mails-view ' + TableView.prototype.className,
    pageSize: 20,
    pageMode: 'pagination',
    header: false,
    selectable: true,
    footerMaxPages: 5,
    searchValue: '',
    selectedLabels: [],
    showPaginator: true,
    showPageSizeSeletor: false,

    init: function() {
      this.folder = undefined;
      this.mailSecId = undefined;
      this.messageCount = 0;
    },

    setFields: function() {
      var fields = [];

      fields.push({
        name: 'Mail',
        className: 'mail',
        view: ListMailView
      });

      return fields;
    },

    setMailSecId: function(secId) {
      this.mailSecId = secId;
      // Reset selectedLabels when changing email addresses
      this.selectedLabels = [];
      this.trigger('change:mailSecId', secId);
      this.refresh();
    },

    setFolder: function(folderId) {    
      this.folder = folderId;    
      this.refresh();
    },

    fetch: function(first, pageSize) {
      var defer = $.Deferred();

      if(this.folder === undefined || this.mailSecId === undefined)
        return defer.resolve([]);

      if(!first) first = 0;
      if(pageSize) this.pageSize = pageSize;

      var params = {};
      params.folder = this.folder;
      params.page = Math.ceil(first/this.pageSize);
      params.size = this.pageSize;

      params.sidx = 'sentDate';
      params.sort = 'sentDate,desc';
      params.search = this.searchValue;
      params.forceRefresh = true;
      
      // Add labels filter if any labels are selected
      if (this.selectedLabels && this.selectedLabels.length > 0) {
        params.labels = this.selectedLabels.join(',');
      }

      if(this.fetchRequest)
        this.fetchRequest.abort();

      this.fetchRequest = $.ajax({
          type: 'GET',
          url: App.request('mails:get-url', this.mailSecId, params),
          headers: {
              'Cache-Control': 'no-cache'
          },
          success: _.bind(function (items) {
              var models = [];

              try {
                // Safely handle pagination/footer info if present
                if (items && items.pageable) {
                  this.pageSize = items.pageable.pageSize || this.pageSize;                 
                  if(items.totalElements)
                    this.messageCount = items.totalElements;
                  if (typeof items.pageable.pageNumber !== 'undefined' && items.pageable.pageNumber !== null) {
                    //setCurrentPage triggers a body fetch; avoid recursion by only adjusting when footer exists
                    this.footerView.setCurrentPage(items.pageable.pageNumber + 1);
                  }                    
                }

                var content = (items && items.content) ? items.content : [];
                _.each(content, _.bind(function(item) {
                  var model = App.request('mails:model', item);
                  models.push(model);
                }, this));
              } catch (e) {
                // In case of any unexpected structure, fall back to empty list
                models = [];
              }

              defer.resolve(models, this.messageCount);
          }, this),
          error: function() {
              defer.resolve([]);
          }
      });

      return defer.promise();
    },

    fetchCount: function() {
      var defer = $.Deferred();
      defer.resolve(this.messageCount);
      return defer.promise();
    },

    onRowClick: function(view) {
      //this.options.onRowClick(view);

      this.mailView = new MailView({
        model: view.model,
        mailSecId: this.mailSecId,
        parentView: this
      });
      this.options.parentView.options.parentView.getRegion('mailRegion').show(this.mailView);
    },

    search: function(value) {
      this.searchValue = value;
      this.refresh();
    },

    clearSearch: function() {
        this.searchValue = '';
    },
    
    filterByLabels: function(labels) {
      this.selectedLabels = labels || [];
      this.refresh();
    },
    
    clearLabelsFilter: function() {
      this.selectedLabels = [];
      this.refresh();
    }
  });
});
